import { render, staticRenderFns } from "./AssignedDoctorCard.vue?vue&type=template&id=757a07dd&scoped=true&"
import script from "./AssignedDoctorCard.vue?vue&type=script&lang=js&"
export * from "./AssignedDoctorCard.vue?vue&type=script&lang=js&"
import style0 from "./AssignedDoctorCard.vue?vue&type=style&index=0&id=757a07dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a07dd",
  null
  
)

export default component.exports